export default __webpack_public_path__ + "static/media/currentLocation.f8c13500.png";